import { render, staticRenderFns } from "./orderHydro.vue?vue&type=template&id=f2531580&scoped=true&"
import script from "./orderHydro.vue?vue&type=script&lang=js&"
export * from "./orderHydro.vue?vue&type=script&lang=js&"
import style0 from "./orderHydro.vue?vue&type=style&index=0&id=f2531580&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2531580",
  null
  
)

export default component.exports